/*
 * Copyright (c) 2022
 * 
 * Created Date: Tuesday, October 4th 2022, 12:23:59 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import * as React from "react"

const IconCopyToClipboard = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M14.4 0h-8c-.882 0-1.6.718-1.6 1.6v3.2H1.6C.718 4.8 0 5.518 0 6.4v8c0 .882.718 1.6 1.6 1.6h8c.882 0 1.6-.718 1.6-1.6v-3.2h3.2c.882 0 1.6-.718 1.6-1.6v-8c0-.882-.718-1.6-1.6-1.6ZM1.6 14.4v-8h8l.002 8H1.6Zm12.8-4.8h-3.2V6.4c0-.882-.718-1.6-1.6-1.6H6.4V1.6h8v8Z"
      fill="#1D1C1D"
    />
  </svg>
)

export default IconCopyToClipboard
